import linkAssetsView from '../app.modal/linkExistingAssetsModal.html';
import linkEntriesCtrl from '../app.modal/appLinkEntriesModalCtrl';
import appFileCtrl from '../app.sidenav/addNewFilesCtrl';
import appFileView from '../app.sidenav/addNewFilesModal.html';

export default function ($rootScope, $scope, $stateParams, $http, $uibModal, ngToast, $state, $q, $cookies, $timeout, CONFIG, UtilitiesFactory, ContentFulFactory, Upload) {
    'ngInject';
    let utilities = UtilitiesFactory.getUtilities();
    let id = $stateParams.id;
    let obj = $stateParams.obj;
    let T = $scope.$root.T;
    let contentTypes = $stateParams.contentTypes;
    let contentType = _.filter(contentTypes, (type) => { return type.name === 'Article' })[0];
    let formControls = contentType.fields;

    $scope.title = null;
    $scope.type = $stateParams.type;
    $scope.obj = {
        link: null
    };
    $scope.setControlsToDirty = utilities.forms.setControlsToDirty;
    $scope.isProgress = false;
    $scope.fileUpload = false;


    console.log(id, $scope.type, contentTypes, obj);

    $scope.image = [];
    // TODO: ng-pattern="urlPattern"
    $scope.urlPattern = (() => {
        let regexp = /(?:http|https):\/\/((?:[\w-]+)(?:\.[\w-]+)+)(?:[\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?$/;
        if ($scope.type !== 'link') {
            test: (value) => {
                return true;
            }
        } else {
            return {
                test: (value) => {
                    return regexp.test(value);
                }
            };
        }
    })();

    /***
     * Init
     */
    let init = () => {
        getUrl();
    };

    /***
     * Get Url from Navigation Item
     */
    let getUrl = () => {
        let  endpoint = `entries?sys.id=${id}&include=5&sys.type[ne]=${(new Date()).valueOf()}`;
        $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
            let navigationItem = data.data.items[0];
            console.log(data.data)
            $scope.navigationItem = navigationItem;
            let fields = !!navigationItem.fields ? navigationItem.fields : {fields: {url: 'link'}};
            let _type = 'link';
            console.log(fields);
            $scope.title = fields.title;

            if (fields.hasOwnProperty('url')) {
                if (!!fields.url && fields.url.indexOf('File') > -1) {
                    _type = 'file';
                } else if (!!fields.url && fields.url.indexOf('Search') > -1) {
                    _type = 'search';
                } else {
                    _type = 'link';
                }
            } else {
                _type = 'link';
            }

            if ($scope.type === _type) {
                if (_type === 'link') {
                    $scope.obj.link = fields.url || '';
                } else if (_type === 'file') {
                    $scope.obj.link = fields.url.split('File:')[1];
                    $scope.mime = _.last($scope.obj.link.split('.')).toLowerCase();
                    $scope.fileName = $scope.obj.link.split('.')[$scope.obj.link.split('.').length - 2].split('/');
                    $scope.fileName = _.last($scope.fileName);
                } else {
                    $scope.obj.link = fields.url.split(':')[1];
                }
            } else {
                $scope.obj.link = null;
            }

            $scope.label = `${T[$scope.type.toUpperCase()]}`;
        });
    };


    /***
     * Show File upload
     */
    $scope.showFileUpload = () => {
        $scope.fileUpload = true;
    };


    /***
     * Hide File upload
     */
    $scope.hideFileUpload = () => {
        $scope.fileUpload = false;
    };

    /***
     * Upload Files
     * @param files
     */
    $scope.uploadFiles = (files) => {
        console.log(files);
        $scope.isProgress = true;
        $scope.uploadImage(files);
    };


    /***
     * Success Upload Image Callback
     * @param asset
     * @param isNew
     */
    let imageSuccessCallback = (asset, isNew = false) => {
        $timeout ( () => {
            let promises = [];
            $scope.isProgress = false;
            let images = []

            if (Array.isArray(asset)) {
                _.forEach(asset, (asst) => {
                    images.push({
                        sys: {
                            "type": "Link",
                            "linkType": "Asset",
                            id: asst.sys.id
                        }
                    });
                });
            } else {
                images.push({
                    sys: {
                        "type": "Link",
                        "linkType": "Asset",
                        id: asset.sys.id
                    }
                });
            }

            _.forEach(images, (item) => {
                let endpoint = `${CONFIG.customUploadUrl}contentful/assets?sys.id=${item.sys.id}&sys.type[ne]=${(new Date()).valueOf()}`;
                promises.push($http.get(endpoint));
            });

            $q.all(promises).then((images) => {
                let index = 0;
                _.forEach(images, (image) => {
                    let data = image.data.items[0];
                    $scope.obj.link = `${data.fields.file.url}`;
                    $scope.mime = data.fields.file.contentType.split('/')[1];
                    $scope.fileName = data.fields.file.fileName;

                    index ++;
                });

                if (isNew) {
                    let modalInstance = $uibModal.open({
                        template: appFileView,
                        controller: appFileCtrl,
                        controllerAs: 'vm',
                        resolve: {
                            isMultipleSelection() {
                                return false;
                            },
                            isNoUpload() {
                                return true;
                            },
                            image() {
                                return asset;
                            }
                        }
                    });

                    modalInstance.result.then((addedImage) => {
                        console.log(addedImage);
                    });
                }
            });
        }, 300);
    };


    /***
     * Error Message Callback
     */
    let imageErrorCallback = () => {
        $timeout( () => {
            $scope.isProgress = false;
            ngToast.create({
                className: 'toast-danger',
                content: `${T.HTTP_UPLOAD_ERROR_NOTIFICATION}`,
                timeout: 6000
            });
        });
    };

    /***
     * Uploading image - Creating Asset - Processing Asset - Publishing Asset - Linking Asset to Entry
     * @param imgs
     */
    $scope.uploadImage = (imgs) => {
        /**
         * Upload image
         */
        if (Array.isArray(imgs)) {
            imgs = _.filter(imgs, (img) => { return !img.hasOwnProperty('__url') })
        } else {
            let img = imgs;
            imgs = null;
            img.push(img);
        }

        let promises = [];
        let contentFulPromises = [];
        _.forEach(imgs, (img) => {
            promises.push( Upload.upload({
                url: `${CONFIG.customUploadUrl}upload`,
                data: {file: img }
            }));
        });

        $q.all(promises).then((images) => {
            console.log(images);
            let index = 0;
            let count = 0;
            let assets = [];
            _.forEach(images, (data) => {
                /**
                 * Create Asset
                 *
                 */
                let img = imgs[index];
                //TODO: CreateAsset from Id
                contentFulPromises.push(ContentFulFactory.createAssetFromFiles());
                ContentFulFactory.createAssetFromFiles()
                    .then((space) => {
                        space.createAsset({
                            fields: {
                                title: {
                                    'en':img.$ngfName
                                },
                                file: {
                                    'en': {
                                        contentType: img.type,
                                        fileName: !!img.$ngfName ? img.$ngfName : img.name,
                                        upload: data.data.url
                                    }
                                }
                            }
                        })
                            .then((asset) => {
                                console.log('processing...', asset);
                                let p1 = asset.processForLocale('en', { processingCheckRetries: 15 });
                                p1.then((value) => {
                                    console.log(value);
                                }).catch((e) => {
                                    imageErrorCallback(e);
                                    $rootScope.raven.captureException(e);
                                    $rootScope.raven.showReportDialog();
                                }).then((error) => {
                                    console.log(error);
                                }, (e) => {
                                    $rootScope.raven.captureException(e);
                                    $rootScope.raven.showReportDialog();
                                });

                                return p1;
                            })
                            .then((asset) => {
                                console.log('publishing...', asset);
                                let p1 = asset.publish();
                                p1.then((value) => {
                                    console.log(value);
                                }).catch((e) => {
                                    imageErrorCallback(e);
                                    $rootScope.raven.captureException(e);
                                    $rootScope.raven.showReportDialog();
                                }).then((error) => {
                                    console.log(error);
                                }, () => {});

                                return p1;
                            })
                            .then((asset) => {
                                count ++;
                                assets.push(asset);
                                if (count === images.length) {
                                    imageSuccessCallback(assets, true);
                                }
                            })
                    })
                    .catch((e) => {
                        $rootScope.raven.captureException(e);
                        $rootScope.raven.showReportDialog();
                        $scope.isProgress = false;
                        ngToast.create({
                            className: 'toast-warning',
                            content: `${T.HTTP_UPLOAD_ERROR_NOTIFICATION}`,
                            timeout: 2500
                        });
                    })
            })
        });
    };


    /***
     * Show Title Editable
     */
    $scope.showParent = () => {
        document.getElementsByClassName('editable-buttons')[0].children[0].innerHTML = T.SAVE;
        document.getElementsByClassName('editable-buttons')[0].children[1].innerHTML = T.CANCEL;
    };


    /***
     *
     * @param data
     */
    $scope.updateParent = (data) => {
        $scope.submit(data.title);
    };

    /***
     * Open File browser on modal
     * @returns {*}
     */
    $scope.openFilesBrowser = () => {
        console.log('openFilesBrower ()');
        let endpoint = `assets?sys.type[ne]=${(new Date()).valueOf()}`;
        let config = {
            errorMessage: T.HTTP_GET_ERROR_NOTIFICATION + $scope.type
        };

        let modalInstance = $uibModal.open({
            template: linkAssetsView,
            controller: linkEntriesCtrl,
            controllerAs: 'vm',
            resolve: {
                id() {
                    return id
                },
                items($http) {
                    return $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`, config);
                },
                entry() {
                    return 'images';
                },
                selectedItems() {
                    return [];
                },
                formControls() {
                    return formControls;
                },
                type() {
                    return 'file';
                }
            }
        });

        modalInstance.result.then((selectedItem) => {
            console.log(selectedItem);
            $scope.image = selectedItem.image;
            $scope.obj.link = `${$scope.image[0].fields.file.url}`;
        }, () => {
            console.log(`Modal dismissed at: ${new Date()}`);
        });
    };


    /***
     * Change type
     * @param type
     */
    $scope.changeType = (type) => {
        $scope.type = type;
        getUrl();
    };

    /***
     * Remove Image
     */
    $scope.removeImg = () => {
        $scope.obj.link = null;
    };

    /***
     * Submit
     */
    $scope.submit = (__title = null) => {
        $scope.isProgress = true;
        let  endpoint = `entries?sys.id=${id}&sys.type[ne]=${(new Date()).valueOf()}`;
        $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
            let navigationItem = data.data.items[0];
            let content = navigationItem.sys;
            let fields = navigationItem.fields;
            let region = JSON.parse($cookies.get('region'));

            if ($scope.type === 'link') {
                fields.url = $scope.obj.link;
            } else if ($scope.type === 'search') {
                fields.url = `Search:${$scope.obj.link}`;
            } else if ($scope.type === 'file') {
                fields.url = `File:${$scope.obj.link}`;
            }

            if (!!__title) {
                fields.title = __title;
            }


            fields.region = {
                sys: {
                    'id': region.sys.id,
                    'type': 'Link',
                    'linkType': 'Entry'
                }
            };

            let config = {
                errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + content.contentType.sys.id,
                headers: {
                    'X-Contentful-Content-Type': content.contentType.sys.id
                }
            };

            let _dataToPost = _.mapValues(fields, value => ({
                en: value
            }));

            console.log(_dataToPost);

            return $http.get(`${CONFIG.cmApiUrl}entries/${id}?sys.type[ne]=${(new Date()).valueOf()}`, config).then(data => {
                let sys = data.data.sys;

                let config = {
                    successMessage: content.contentType.sys.id + T.HTTP_POST_SUCCESS_NOTIFICATION,
                    errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + content.contentType.sys.id,
                    headers: {
                        'X-Contentful-Version': sys.version
                    }
                };
                return $http.put(`${CONFIG.cmApiUrl}entries/${id}` , {fields: _dataToPost}, config).then(data => {
                    sys = data.data.sys;

                    let config = {
                        successMessage: content.contentType.sys.id + T.HTTP_PUT_SUCCESS_NOTIFICATION,
                        errorMessage: T.HTTP_PUT_ERROR_NOTIFICATION + content.contentType.sys.id,
                        headers: {
                            'X-Contentful-Version': sys.version
                        }
                    };

                    let title = ($scope.type === 'link') ? T.LINK : T.SEARCH;
                    return $http.put(`${CONFIG.cmApiUrl}entries/${id}/published`, null, config).then(() => {
                        ngToast.create({
                            className: 'toast-success',
                            content: `${title} ${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                            timeout: 2500
                        });

                        $scope.isProgress = false;
                        if (!!__title) {
                            $state.reload();
                        } else {
                            $state.go('^.navigationitem', {
                                id: id,
                                type: $scope.type
                            });
                        }

                    }, (e) => {
                        $rootScope.raven.captureException(e);
                        $rootScope.raven.showReportDialog();
                    });
                });
            });
        });
    };

    init();
}



// WEBPACK FOOTER //
// ./src/app/views/app.navigationitem/appNavigationItemCtrl.js